<template>
  <div>
    <div>The Data</div>
    <!-- <button @click="updateOneConfig">save</button> -->
    <div class="data-area" v-if="configLoaded">
      <div class="controls">
        <div>Controls</div>
        <div
          class="control"
          v-for="(control, controlIndex) in allowedRows"
          :key="controlIndex"
          @click="toggleAllowed(controlIndex)"
        >
          <input type="checkbox" :checked="control.allowed" />
          <div>{{ control.tableName }}</div>
        </div>
      </div>
      <div class="table-container">
        <button @click="setView('sessions')">Explore sessions</button>
        <button @click="newDataSnapshot">+ New data snapshot</button>
        <div>{{ snapshotStatusText }}</div>
        <div class="table-row">
          <div class="top-row">
            <div>
              <div class="row-field box created-box">Created date</div>
            </div>
            <div v-for="(rowField, index) in allowedRows" :key="index">
              <div class="row-field box" v-if="rowField.allowed">
                {{ rowField.tableName }}
              </div>
            </div>
          </div>
          <div v-if="snapshots && snapshots.length">
            <div
              v-for="snapshot in snapshots"
              :key="snapshot._id"
              class="snapshot"
            >
              <!-- <div class="snapshot-header">
              <button
                class="snapshot-delete"
                @click="deleteDataSnapshot(snapshot._id)"
              >
                Delete
              </button>
            </div> -->
              <div class="rowContainer">
                <div class="row-value box created-box">
                  {{ getSnapshotDatetime(snapshot) }}
                </div>
              </div>
              <div
                class="rowContainer"
                v-for="(rowField, indy) in allowedRows"
                :key="indy"
              >
                <div
                  v-if="snapshot[rowField.name] && rowField.allowed"
                  class="row-field box"
                >
                  {{ snapshot[rowField.name] }}
                </div>
                <div
                  v-else-if="!snapshot[rowField.name] && rowField.allowed"
                  class="row-field box"
                >
                  N/A
                </div>
              </div>
              <button
                class="snapshot-delete"
                @click="deleteDataSnapshot(snapshot._id)"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
        <div style="display: flex">
          <div class="control" @click="toggleGraph('bothJoined')">
            <input type="checkbox" :checked="graphOptions.bothJoined" />
            <div>Both joined</div>
          </div>
          <button @click="setGraphView('1D')">1D</button>
          <button @click="setGraphView('1W')">7D</button>
          <button @click="setGraphView('2W')">14D</button>
          <button @click="setGraphView('1M')">1M</button>
          <button @click="setGraphView('3M')">3M</button>
          <button @click="setGraphView('6M')">6M</button>
          <button @click="setGraphView('MAX')">MAX</button>
          <span style="margin-left: 5px"
            >(Filters only apply for graph currently)</span
          >
          <!-- <Datepicker
            v-model="graphOptions.startDate"
            placeholder="Pick start date"
            name="startpicker"
          /> -->
        </div>
        <LineChart
          v-if="pastSessions && pastSessions.length"
          :filteredData="getChartData"
        />
        <div
          style="width: 100%; overflow-x: scroll"
          v-if="pastSessions && pastSessions.length"
        >
          <div style="display: flex">
            <div class="box week-box">Week</div>
            <div class="box">Low active (1-5)</div>
            <div class="box">Active (6-20)</div>
            <div class="box">Highly active (21-40)</div>
            <div class="box">Power users (40+)</div>
            <div class="box">Total nr of sessions</div>
          </div>
          <div
            class="week"
            style="display: flex"
            v-for="(week, weekIndex) in getTableSessionsData"
            :key="weekIndex"
          >
            <div class="week-box">
              {{
                `Week ${weekIndex + 1}: ${getFormattedDatetime(week.startDate)}`
              }}
            </div>
            <div class="week-row" style="display: flex">
              <div class="box">{{ week.activitySorted.lowActive.count }}</div>
              <div class="box">{{ week.activitySorted.active.count }}</div>
              <div class="box">
                {{ week.activitySorted.highlyActive.count }}
              </div>
              <div class="box">{{ week.activitySorted.powerUsers.count }}</div>
              <div class="box">{{ week.sessions.length }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataMaster from "./DataMaster";
import LineChart from "./charts/LineChart.vue";
// import Datepicker from "vuejs-datepicker";
import { mapState } from "vuex";
import {
  format,
  isSameDay,
  isSameWeek,
  endOfWeek,
  startOfDay,
  subDays,
  subMonths,
} from "date-fns";
import { computeGraph } from "./dataHelper";

export default {
  name: "Data",
  components: {
    LineChart,
    // Datepicker,
  },
  data() {
    return {
      snapshots: [],
      snapshotStatusText: "All snapshots:",

      chartData: {
        labels: [],
        datasets: [
          {
            label: "Sessions done that day",
            data: [],
            fill: false,
            borderColor: "#2554FF",
            backgroundColor: "#2554FF",
            borderWidth: 1,
          },
        ],
      },
      chartOptions: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
      },

      pastSessions: [],

      options: {
        exploreByWeek: true,
        activity: true,
      },

      configLoaded: false,

      graphOptions: {
        bothJoined: false,
        startDate: null,
        endDate: null,
        view: "1D",
      },

      startDate: null,
      endDate: null,

      view: "users",

      allowedRows: [
        { allowed: true, name: "nrIs0", tableName: "0 sessions" },
        { allowed: true, name: "nrIs1", tableName: "1 session" },
        { allowed: true, name: "nrIs2", tableName: "2 sessions" },
        { allowed: true, name: "nrIs3", tableName: "3 sessions" },
        { allowed: true, name: "nrIs4", tableName: "4 sessions" },
        { allowed: true, name: "nrIs5", tableName: "5 sessions" },
        { allowed: true, name: "nrIs6", tableName: "6 sessions" },
        { allowed: true, name: "nrIs7", tableName: "7 sessions" },
        { allowed: true, name: "nrIs8", tableName: "8 sessions" },
        { allowed: true, name: "nrIs9", tableName: "9 sessions" },
        { allowed: true, name: "nrIs10", tableName: "10 sessions" },
        { allowed: true, name: "nrMoreThan0", tableName: "> 0 sessions" },
        { allowed: true, name: "nrMoreThan1", tableName: "> 1 sessions" },
        { allowed: true, name: "nrMoreThan2", tableName: "> 2 sessions" },
        { allowed: true, name: "nrMoreThan3", tableName: "> 3 sessions" },
        { allowed: true, name: "nrMoreThan4", tableName: "> 4 sessions" },
        { allowed: true, name: "nrMoreThan5", tableName: "> 5 sessions" },
        { allowed: true, name: "nrMoreThan6", tableName: "> 6 sessions" },
        { allowed: true, name: "nrMoreThan7", tableName: "> 7 sessions" },
        { allowed: true, name: "nrMoreThan8", tableName: "> 8 sessions" },
        { allowed: true, name: "nrMoreThan9", tableName: "> 9 sessions" },
        { allowed: true, name: "nrMoreThan10", tableName: "> 10 sessions" },
        { allowed: true, name: "nrMoreThan20", tableName: "> 20 sessions" },
        { allowed: true, name: "nrMoreThan30", tableName: "> 30 sessions" },
        { allowed: true, name: "nrMoreThan50", tableName: "> 50 sessions" },
        { allowed: true, name: "nrMoreThan100", tableName: "> 100 sessions" },
        { allowed: true, name: "nrMoreThan150", tableName: "> 150 sessions" },
        { allowed: true, name: "nrMoreThan200", tableName: "> 200 sessions" },
        { allowed: true, name: "nrMoreThan250", tableName: "> 250 sessions" },
        { allowed: true, name: "nrMoreThan300", tableName: "> 300 sessions" },
        { allowed: true, name: "nrMoreThan350", tableName: "> 350 sessions" },
        { allowed: true, name: "nrMoreThan400", tableName: "> 400 sessions" },
        { allowed: true, name: "nrMoreThan500", tableName: "> 500 sessions" },
        { allowed: true, name: "nrMoreThan600", tableName: "> 600 sessions" },
        {
          allowed: true,
          name: "nrMoreThan10LessThan50",
          tableName: "> 10 & < 50",
        },
        {
          allowed: true,
          name: "nrMoreThan50LessThan100",
          tableName: "> 50 & < 100",
        },
        { allowed: true, name: "nrVerified", tableName: "Nr of verified" },
        { allowed: true, name: "nrUnverified", tableName: "Nr of unverified" },
        { allowed: true, name: "nrOfUsers", tableName: "Nr of users" },
      ],
    };
  },
  async created() {
    await this.getAllSnapshots();
    let allowed = await DataMaster.getViewConfig(this.user._id);
    if (allowed) {
      console.log("allowed: ", allowed);
      this.allowedRows = allowed;
      this.configLoaded = true;
    } else {
      this.configLoaded = true;
    }

    window.addEventListener(
      "beforeunload",
      this.updateBeforeLeave
    ); /* helps detect refresh */
  },
  beforeDestroy() {
    this.updateBeforeLeave();
  },
  beforeRouteLeave(to, from, next) {
    this.updateBeforeLeave(true, next);
  },
  mounted() {
    this.setGraphView("1D");
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    getTableSessionsData() {
      /* Sessions done by day across all time */
      const pastSessions = this.pastSessions;
      /* Per new day, sort sessions into days */

      const uniqueDatesSegmentation = [];
      for (const session of pastSessions) {
        if (!session.timestamps || !session.timestamps.length) {
          continue;
        }
        const found = uniqueDatesSegmentation.some((day) =>
          isSameDay(new Date(day.date), new Date(session.dateTime))
        );
        if (!found) {
          const newDay = {
            date: session.dateTime,
            sessions: [session],
          };
          uniqueDatesSegmentation.push(newDay);
        } else {
          const index = uniqueDatesSegmentation.findIndex((day) =>
            isSameDay(new Date(day.date), new Date(session.dateTime))
          );
          uniqueDatesSegmentation[index].sessions.push(session);
        }
      }

      let weeks = [];
      if (this.options.exploreByWeek) {
        for (const day of uniqueDatesSegmentation) {
          //   the day of week, 0 represents Sunday
          if (!weeks || !weeks.length) {
            let week = {
              startDate: day.date,
              endDate: endOfWeek(new Date(day.date), { weekStartsOn: 1 }),
              sessions: day.sessions,
            };
            weeks.push(week);
          } else {
            /* If last item, e.g. from the end */
            const latestWeek = weeks.at(-1);
            if (
              isSameWeek(new Date(latestWeek.startDate), new Date(day.date), {
                weekStartsOn: 1,
              })
            ) {
              weeks.at(-1).sessions = [...latestWeek.sessions, ...day.sessions];
            } else {
              let week = {
                startDate: day.date,
                endDate: endOfWeek(new Date(day.date), { weekStartsOn: 1 }),
                sessions: day.sessions,
              };
              weeks.push(week);
            }
          }
        }
      }
      if (this.options.activity) {
        for (const [wIndex, week] of weeks.entries()) {
          let uniqueUserIDs = [];
          let usersData = [];
          for (const sesh of week.sessions) {
            for (const userID of sesh.UIDs) {
              if (!uniqueUserIDs.includes(userID)) {
                uniqueUserIDs.push(userID);
                let newUserData = {
                  userID,
                  sessionsThisWeek: [sesh],
                };
                usersData.push(newUserData);
              } else {
                let userIndex = usersData.findIndex(
                  (user) => user.userID === userID
                );
                usersData[userIndex].sessionsThisWeek.push(sesh);
              }
            }
          }
          weeks[wIndex]["uniqueUserIDs"] = uniqueUserIDs;
          weeks[wIndex]["usersData"] = usersData;
          weeks[wIndex]["activitySorted"] = {
            lowActive: {
              count: 0,
              users: [],
            },
            active: {
              count: 0,
              users: [],
            },
            highlyActive: {
              count: 0,
              users: [],
            },
            powerUsers: {
              count: 0,
              users: [],
            },
          };
          const activitySorted = weeks[wIndex]["activitySorted"];
          for (const u of weeks[wIndex]["usersData"]) {
            let totalAttended = 0;

            for (const userSesh of u.sessionsThisWeek) {
              for (const stamp of userSesh.timestamps) {
                if (stamp.UID == u.userID) {
                  totalAttended++;
                  break;
                }
              }
            }
            if (totalAttended > 0 && totalAttended <= 5) {
              activitySorted["lowActive"].count++;
              activitySorted["lowActive"].users.push(u);
            } else if (totalAttended > 5 && totalAttended <= 20) {
              activitySorted["active"].count++;
              activitySorted["active"].users.push(u);
            } else if (totalAttended > 20 && totalAttended <= 40) {
              activitySorted["highlyActive"].count++;
              activitySorted["highlyActive"].users.push(u);
            } else if (totalAttended > 40) {
              activitySorted["powerUsers"].count++;
              activitySorted["powerUsers"].users.push(u);
            }
          }
        }
      }
      return weeks;
    },
    getChartData() {
      const pastSessions = JSON.parse(JSON.stringify(this.pastSessions));
      const graphOptions = JSON.parse(JSON.stringify(this.graphOptions));
      const chartData = JSON.parse(JSON.stringify(this.chartData));
      const chartOptions = JSON.parse(JSON.stringify(this.chartOptions));
      return computeGraph(
        pastSessions,
        graphOptions,
        chartData,
        chartOptions
      );
    },
  },
  methods: {
    async updateBeforeLeave(fromBeforeLeave = false, next = null) {
      window.removeEventListener("beforeunload", this.updateBeforeLeave);
      await this.updateOneConfig();
      if (fromBeforeLeave && next !== null) {
        next();
      }
    },
    async saveViewConfig() {
      const data = {
        userID: this.user._id,
        allowedRows: this.allowedRows,
      };
      await DataMaster.saveViewConfig(data);
    },
    async updateOneConfig() {
      const data = {
        userID: this.user._id,
        allowedRows: this.allowedRows,
      };
      await DataMaster.updateOneConfig(data);
    },
    async getAllSnapshots() {
      this.snapshots = await DataMaster.getAllSnapshots();
    },
    async getAllPastSessions() {
      this.snapshotStatusText = "Getting past sessions data...";
      const sessions = await DataMaster.getAllPastSessions();
      console.log("sessions:", sessions);
      if (!sessions || !sessions.length) return console.log("no sessions found");
      this.snapshotStatusText = "Data is ready, loading...";
      await this.delay(1000);
      this.snapshotStatusText = "All snapshots:";
      this.pastSessions = sessions;
    },
    async newDataSnapshot() {
      this.snapshotStatusText = "Creating new snapshot...";
      const snapshot = await DataMaster.newDataSnapshot();
      this.snapshotStatusText = "Snapshot ready. Loading...";
      await this.delay(1000);
      this.snapshotStatusText = "All snapshots:";
      this.snapshots.push(snapshot);
    },
    async deleteDataSnapshot(snapshotID) {
      await DataMaster.deleteDataSnapshot(snapshotID);
      const snapshotIndex = this.snapshots.findIndex(
        (snapshot) => snapshot._id === snapshotID
      );
      this.snapshots.splice(snapshotIndex, 1);
    },
    async delay(ms) {
      return new Promise((res) => setTimeout(res, ms));
    },
    getSnapshotDatetime(snapshot) {
      return format(new Date(snapshot.createdAt), `MMMM d, y, HH:mm`);
    },
    getFormattedDatetime(datetime) {
      return format(new Date(datetime), `MMMM d, y`);
    },
    allowedRow(key) {
      const allowed_rows = this.allowedRows;
      const found = allowed_rows.some((field) => field.name === key);
      if (found) {
        return true;
      }
      return false;
    },
    toggleAllowed(index) {
      this.allowedRows[index].allowed = !this.allowedRows[index].allowed;
    },
    toggleGraph(field) {
      this.graphOptions[field] = !this.graphOptions[field];
    },
    async setView(view) {
      this.view = view;
      if (view === "sessions") {
        await this.getAllPastSessions();
      }
    },
    setGraphView(view) {
      let startDate = null;
      let endDate = new Date();
      if (view === "1D") {
        /* Get current day, then set its start and end as start-end dates */
        startDate = startOfDay(endDate);
      } else if (view === "1W") {
        /* Get current week, then set start as last 7 days ago ? */
        startDate = subDays(endDate, 7);
      } else if (view === "2W") {
        /* Get current week, subtract and set start as then */
        startDate = subDays(endDate, 14);
      } else if (view === "1M") {
        startDate = subMonths(endDate, 1);
      } else if (view === "3M") {
        startDate = subMonths(endDate, 3);
      } else if (view === "6M") {
        startDate = subMonths(endDate, 6);
      } else if (view === "MAX") {
        startDate = new Date(2020, 0, 1, 10, 0, 0, 0);
      } else if (view === "custom") {
        startDate = this.startDate;
        endDate = this.endDate;
      }

      this.graphOptions.startDate = startDate;
      this.graphOptions.endDate = endDate;
      this.graphOptions.view = view;
    },
  },
};
</script>

<style scoped>
.snapshot {
  display: flex;
}
.table-container {
  width: 100%;
  overflow-x: hidden;
}
.table-row {
  display: flex;
  flex-direction: column;
  overflow-x: scroll;
  width: 100%;
  padding-bottom: 22px;
}
.table-row .rowContainer {
  display: flex;
}
.table-row .rowContainer .row {
  display: flex;
  flex-direction: column;
}
.table-row .top-row {
  display: flex;
}
.box {
  width: 140px;
  min-width: 140px;
  padding: 3px;
  border: 1px solid;
  box-sizing: border-box;
  overflow-x: scroll;
  white-space: nowrap;
  text-align: right;
  border-top: unset;
  border-right: unset;
}
.created-box {
  width: 250px;
}
.data-area {
  display: flex;
}
.control {
  display: flex;
  cursor: pointer;
}
.control:hover {
  background-color: #efefef;
}
.week-box {
  width: 260px;
  box-sizing: border-box;
  white-space: nowrap;
  min-width: 260px;
  overflow-x: scroll;
}
</style>
